import { useQuery } from '@tanstack/react-query'

import { queryKeys } from 'api/consts'
import { getConfiguration } from 'services/config'

import { fetchPendingConversations } from './api'

const { processingConversationsRefetchInterval } = getConfiguration()

export const usePendingConversationsQuery = ({ enabled }: { enabled: boolean }) => useQuery(
  {

    enabled,
    queryKey: [queryKeys.pendingConversations],
    queryFn: () => fetchPendingConversations(),
    refetchInterval: processingConversationsRefetchInterval,
  })
